(function () {
  document.querySelectorAll('[data-bdc-bestsellers-track]').forEach(function (track) {
    var section = track.closest('.bdc-bestsellers');
    if (!section) return;
    var dotsWrap = section.querySelector('[data-bdc-bestsellers-dots]');
    if (!dotsWrap) return;

    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.bdc-bestsellers__dot'));
    var cards = Array.prototype.slice.call(track.querySelectorAll('.bdc-bestsellers__card'));
    if (!dots.length || !cards.length) return;

    function setActiveDot(index) {
      dots.forEach(function (dot) { dot.classList.remove('is-active'); });
      if (dots[index]) dots[index].classList.add('is-active');
    }

    var scrollTimeout;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var center = track.scrollLeft + track.clientWidth / 2;
          var closest = 0;
          var closestDist = Infinity;
          cards.forEach(function (card, i) {
            var cardCenter = card.offsetLeft + card.offsetWidth / 2;
            var dist = Math.abs(cardCenter - center);
            if (dist < closestDist) {
              closestDist = dist;
              closest = i;
            }
          });
          setActiveDot(closest);
        }, 80);
      },
      { passive: true }
    );
  });
})();